const React = require("react");
const createReactClass = require('create-react-class');

const InputMixin = require("./FormInputMixin.jsx");

module.exports = createReactClass({
	mixins: [InputMixin],
	setFileValue: function (event) {
		this.setState({
			value: event.currentTarget.files[0],
			isValid: true
		});
	},
	render: function () {
		let className = 'form-control';
		let alert;
		if (!this.state.isValid) {
			alert = (
				<div className='validation-message'>
					{this.state.serverError || this.props.validationError}
				</div>
			);
			className += ' validation-error';
		}
		return (
			<div>
				{alert}
				<input
					id={this.props.name}
					type="file"
					className={className}
					name={this.props.name}
					onChange={this.setFileValue}
					disabled={this.props.disabled}
					placeholder={this.props.placeholder}
				/>
			</div>
		);
	}
});
